"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_utils_1 = require("@nef/style-utils");
var Text_1 = __importDefault(require("../../Text"));
var FormGroup_1 = __importDefault(require("./components/FormGroup"));
var FormLabel_1 = __importDefault(require("./components/FormLabel"));
var FormText_1 = __importDefault(require("./components/FormText"));
var FormBaseInput = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, feedback = _a.feedback, helpText = _a.helpText, id = _a.id, invalid = _a.invalid, valid = _a.valid, label = _a.label, optional = _a.optional, rtl = _a.rtl, props = __rest(_a, ["children", "className", "feedback", "helpText", "id", "invalid", "valid", "label", "optional", "rtl"]);
    return (react_1.default.createElement(FormGroup_1.default, __assign({}, props, { ref: ref, className: className ? style_utils_1.classNames([className + "-wrapper"], className) : undefined, id: id ? id + "-wrapper" : undefined }),
        label && (react_1.default.createElement(FormLabel_1.default, { htmlFor: id, rtl: rtl },
            !optional ? react_1.default.createElement(Text_1.default, null, "*") : null,
            label)),
        children,
        ((invalid && feedback) || (!invalid && helpText)) && (react_1.default.createElement(FormText_1.default, { rtl: rtl, invalid: invalid }, invalid ? feedback : helpText))));
});
FormBaseInput.displayName = "FormBaseInput";
exports.default = FormBaseInput;
//# sourceMappingURL=index.js.map